import { Theme, useChakraTheme } from '@hover/blueprint';
import React from 'react';
import { createGlobalStyle } from 'styled-components';

const Styles = createGlobalStyle<{ theme: Theme }>`
  div.firebase-emulator-warning[style] {
    position: fixed !important;
    top: ${props => props.theme.space[300]} !important;
    right: ${props => props.theme.space[300]} !important;
    left: ${props => props.theme.space[300]} !important;
    bottom: unset !important;
    background-color: ${props => props.theme.colors.danger100} !important;
    transform: translateY(-100px);
    width: auto !important;
    height: auto !important;
    border-radius: ${props => props.theme.radii[300]} !important;
    border-width: 0 !important;
    box-shadow: ${props => props.theme.shadows.distance500};
    font-family: ${props => props.theme.fonts.body};
    display: flex;
    padding: ${props => props.theme.space[300]} ${props =>
  props.theme.space[400]};
    justify-content: center;
    align-items: center;
    transition: transform ease 0.25s;
    z-index: 100;
    
    &:before {
      align-items: center;
      background: ${props => props.theme.colors.warning100};
      border-color: ${props => props.theme.colors.warning300};
      box-shadow: 1px 3px 10px 5px rgba(0, 0, 0, 0.05);
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      border-style: solid;
      border-width: 2px;
      content: '🤡';
      display: flex;
      font-size: 20px;
      height: ${props => props.theme.sizes.size300};
      justify-content: center;
      opacity: 0.75;
      position: absolute;
      right: 0;
      top: 0;
      transform: translateY(100px);
      width: ${props => props.theme.sizes.size300};
      transition-property: opacity, transform;
      transition-duration: 0.25s;
      transition-timing-function: ease;
      z-index: 99;
    }
    
    &:hover {
      transform: translateY(0);
      
      &:before {
        opacity: 0;
        transform: translateY(0);
      }
    }
  }
`;

const FirebaseWarningStyles = () => <Styles theme={useChakraTheme()} />;

export { FirebaseWarningStyles };
